<template>
  <div class="page">
    <div class="div-header-select">

      <div class="div-center">
        <div>导入时间</div>
        <el-date-picker
          size="medium"
          v-model="daterange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
    </div>

    <main>
      <el-table  :data="listData"  height="calc(100vh - 200px)" style="width: 100%">
      <!-- <el-table  :data="listData_T" style="width: 100%"> -->
        <el-table-column prop="operatorName" label="操作者名称" align="center">
        </el-table-column>
        <el-table-column prop="opTime" label="导入时间" align="center">
        </el-table-column>
        <el-table-column prop="importType" label="导入类型" align="center">
        </el-table-column>
        <el-table-column label="导入结果" align="center">
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  content="test"
                  width="400px"
                  trigger="click"
                >
                <span >数据总数：{{scope.row.importResult.totalNum}}， 成功数：{{scope.row.importResult.importedNum}} ， 失败数：{{scope.row.importResult.failedNum}} </span>
                  <el-table :data="scope.row.importResult.failedList" max-height="400px">
                    <el-table-column
                      width="150"
                      property="row"
                      label="行号"
                    ></el-table-column>
                    <el-table-column
                      width="150"
                      property="reason"
                      label="失败原因"
                    ></el-table-column>
                  </el-table>
                  <div slot="reference" class="name-wrapper">
                    <el-tag style="cursor:pointer" size="medium">成功：{{scope.row.importResult.importedNum}}，失败：{{scope.row.importResult.failedNum}}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
        <el-table-column prop="importFile" label="源文件" align="center">
          <template scope="scope">
            <a  style="cursor:pointer;color: #409EFF;" @click="downloadFile(scope.row,scope.row.importFile)">{{ scope.row.importFile }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="errFile" label="失败文件" align="center">
          <template scope="scope">
            <a  style="cursor:pointer;color: #409EFF;" @click="downloadFile(scope.row,scope.row.errFile)">{{ scope.row.errFile }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="comment" label="备注" width="400vw"  align="center">
          <template  scope="scope">
            <div v-if="!scope.row.edit" >
              <a v-if="scope.row.comment" style="cursor:pointer;" @click="scope.row.edit = !scope.row.edit,scope.row.tmpComment=scope.row.comment">{{scope.row.comment}}</a>
              <a v-else style="cursor:pointer;color: #C0C4CC;" @click="scope.row.edit = !scope.row.edit,scope.row.tmpComment=scope.row.comment">点击编辑备注</a>
            </div>
            <div v-else>
              <el-input
                v-model="scope.row.tmpComment"
                size="mini"
                style="width:300px; "
                placeholder="编辑备注"
                clearable
                v-focus  
              />
              <el-button style="margin-left: 5px;padding: 3px;" @click="scope.row.edit = !scope.row.edit,submit(scope.row)" type="success" icon="el-icon-check" circle size="mini" ></el-button>
              <el-button style="margin-left: 5px;padding: 3px;" @click="scope.row.edit = !scope.row.edit,scope.row.tmpComment=''" type="danger" icon="el-icon-close" circle size="mini" ></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </main>

    <footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIdx"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="itemTotal"
        :page-sizes="[10, 20, 30, 40, 50]"
      >
      </el-pagination>
    </footer>
  </div>
</template>

<script>
import Utils from "../../Utils";
import { Loading } from "element-ui";
import axios from "axios";
import mixins from "../../minix";

export default {
  name: "Contract",

  mixins: [mixins],

  watch: {
    areaIDSelect() {
      this.initQuery();
    },

    daterange() {
      this.initQuery();
    }
  },

  data() {
    return {
      commentStr:"",
      isInput:false,
      dialogVisible: false,
      uploadUrl: "",
      uploadData: {
        leaseID: ""
      },
      daterange: ""
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");
    this.query(0);
  },

  methods: {
    submit(row){
      if(row.tmpComment!=row.comment){
        
        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
      axios({
        method: "post",
        url: "importlogs/edit",
        data: {
          id:row.id,
          orgID:row.orgID,
          comment:row.tmpComment,
        }
      })
        .then(value => {
          let message = value.data.message;
          if (value.data.code === 0) {
            this.$message.success(message);
            row.comment = row.tmpComment
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
            loading.close();
          });
      }
    },
    downloadFile(item,fileName) { 
      let baseURL = axios.defaults.baseURL.replace("/v1/org", "");

        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
      axios({
        method: "get",
        url: `${baseURL}importlogs/${item.orgID}/${item.operatorID}/${fileName}`,
        responseType: "blob"
      })
        .then(value => {
          Utils.convertRes2Blob(fileName, value);
          this.$message.success("文件下载成功");
        })
        .catch(e => {
          this.$message.error(e.toString());
        })
        .finally(()=>{
          loading.close();
        });
    },
    handleCurrentChange(val) {
      this.pageIdx = val;
      this.query(val - 1);
    },
    handleSizeChange(val) {
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },

    initQuery() {
      this.pageIdx = 0;
      this.query(this.pageIdx);
    },

    query(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }

      let data = {
        orgID: this.$route.query.orgID,
        pageSize: this.pageSize,
        pageIdx: pageIdx,
      };

      if(Array.isArray(this.daterange)) {
        data.start = parseInt(this.daterange[0].getTime() / 1000);
        data.end = parseInt(this.daterange[1].getTime() / 1000 + 60 * 60 * 24 -1);
      }

      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: "importlogs",
        data: data
      })
        .then(value => {
          this.listData = []
          this.itemTotal = value.data.total;
           
          if (value && value.data && value.data.data) {
            value.data.data.forEach(item => {
              item.opTime = Utils.long2second(item.opTime * 1000);
              item.edit=false
              item.tmpComment="" 
              this.listData.push(item);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../style.css";
main {
  margin-top: 10px;
}
</style>
